import ReactDOM from 'react-dom/client';
import React from 'react';
import App from '../components/App';
// Support component names relative to this directory:
// Exclude test files from the production build
// The regex /^(?!.*__tests__).*$/ excludes any path containing '__tests__'
// This prevents webpack from trying to compile test files which:
// - Use testing libraries not available in production
// - Import test utilities from outside the webpack source path
// - Are not needed in the production bundle
var componentRequireContext = require.context("components", true, /^(?!.*__tests__).*$/);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

const root = document.getElementById("root");
if (root) {
  ReactDOM.createRoot(root).render(
    <App />
  );
}
